import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  BreadcrumbMain, Breadcrumb, BreadcrumbContainer, BreadcrumbItem,
} from '../../../components/Navigation/css';
import SvgIcon from '../icons/SvgIcon';

const Breadcrumbs = (props) => {
  const { items, nopadding } = props;
  return (
    <BreadcrumbMain className={nopadding}>
      <Breadcrumb>
        <BreadcrumbContainer>
          <BreadcrumbItem>
            <p>{t('BreadcrumbHomepageTitle')}</p>
          </BreadcrumbItem>
          {
                        items && items.map((item, index) => (
                          <React.Fragment key={`breadcrumb-${index}`}>
                            <BreadcrumbItem>
                              <SvgIcon icon="ArrowRightIcon" />
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                              <p>{item}</p>
                            </BreadcrumbItem>
                          </React.Fragment>
                        ))
                    }
        </BreadcrumbContainer>
      </Breadcrumb>
    </BreadcrumbMain>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.array,
  nopadding: PropTypes.string,
};

export default Breadcrumbs;
